<template>
  <header style="background-color: #F7FFF4 !important;">
    <div class="container">
      <div class="header-section d-flex justify-content-between">
        <div class="header-logo d-flex align-items-center">
          <router-link to="/applicant">
            <img
              src="@/assets/images/bloomlogo.png"
              alt="logo"
              class="img-fluid"
            />
          </router-link>
          <div class="header-list d-flex align-items-center ml-3 mt-2">
            <div class="company-section">
              <span class="font-bold font-15"> {{ user.companyName }} </span><br/>
              <span>ログインユーザー: {{ user.name }} </span>
            </div>
          </div>
        </div>
        <div class="header-list d-flex" style="padding: 15px 0px 0px 0px;">
          <ul class="d-flex header-ul">
             <!-- New Pending Review Tab -->
            <li v-show="showPendingReviewTab()">
              <router-link
                to="/pending-applicants"
                id="pending-applicants"
                class="d-flex align-items-end"
                :class="{
                  'router-link-exact-active router-link-active active': $route.path.startsWith(
                    '/pending-applicants'
                  ),
                }"
              >
                確認待ち
              </router-link>
            </li>
            <li v-show="isCreateReviewUser">
              <router-link
                to="/applicant"
                id="applicants"
                class="d-flex align-items-end"
              >
                <!-- <i class="fa fa-users" aria-hidden="true"></i> -->
                登録者一覧
              </router-link>
            </li>
            <!-- <li v-show="isCreateReviewUser">
              <router-link
                to="/job-description-list"
                id="job-description-list"
                class="d-flex align-items-end"
              >
               求人一覧
              </router-link>
            </li> -->
            <li v-show="isCreateReviewUser">
              <router-link
                to="/scout-applicant"
                id="scout-applicant"
                class="d-flex align-items-end"
              >
                スカウト対象
              </router-link>
            </li>

            <!-- <li v-show="hasJDAuthority">
              <router-link to="/job-description-list/user-filter" id="matching" class="d-flex align-items-end" @click.native="handleJDListClick">
                JD一覧
              </router-link>
            </li> -->
            <!-- <li v-show="isAdmin || isCreateReviewUser">
              <router-link to="/dashboard" id="dashboard" class="d-flex align-items-end">

                プロセス実績
              </router-link>
            </li> -->
            <li v-show="isCreateReviewUser">
              <router-link
                to="/contact-list/received-list"
                id="contacts"
                class="d-flex align-items-end"
                :class="{
                  'router-link-exact-active router-link-active active': $route.path.startsWith(
                    '/contact-list'
                  ),
                }"
              >
              <span id="unreadCount"
                  class="font-weight-bold
                  d-inline-flex justify-content-center align-items-center unreadCount"
                  >{{ contactCount || 0 }}</span>
                <span>送受信履歴</span>
              </router-link>
            </li>
            <li v-show="isCreateReviewUser">
              <router-link
                :to="settingsLink"
                id="settings"
                class="d-flex align-items-end"
                :class="{
                  'router-link-exact-active router-link-active active': $route.path.startsWith(
                    '/setting'
                  ),
                }"
              >
                <!-- <i class="fa fa-cog" aria-hidden="true"></i> -->
                設定
              </router-link>
            </li>

            <li>
              <router-link to="/logout" id="logout" class="d-flex align-items-end">

                ログアウト
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="position-absolute custom-alert">
      <Notification
        v-for="(msg, idx) in getAllFlashMessages"
        :message="msg"
        :idx="idx"
        :key="idx"
      />
    </div>
  </header>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import mutations from '@/config/mutations';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Notification from '../utils/Notification';

export default {
  name: 'Header',
  components: { Notification },
  computed: {
    ...mapGetters({
      isAdmin: 'currentUserIsAdmin',
      isCreateReviewUser: 'isCreateReviewUser',
      user: 'getCurrentUser',
      getContactCount: 'getRepliedContactCount',
      companyContactAuthority: 'getCompanyContactAuthority',
      jdMatchingAuthority: 'getJdMatchingAuthority',
      userContactAuthority: 'getUserContactAuthority',
      reviewLists: 'getReviewLists',
      assignedReviewLists: 'getAssignedReviewLists',
      hasAssignedApplicants: 'getHasAssignedApplicants',
    }),
    ...mapGetters(['getAllFlashMessages']),
    globalUser() {
      return true;
    },
    contactCount() {
      return this.getContactCount;
    },
    hasIndividualContactAuthority() {
      return this.isCreateReviewUser && this.companyContactAuthority;
    },
    hasJDAuthority() {
      return this.jdMatchingAuthority && this.isCreateReviewUser;
    },

    settingsLink() {
      const links = [
        {
          path: '/setting/review-list',
          label: 'リスト設定',
          show: this.isCreateReviewUser,
        },
        {
          path: '/setting/users',
          label: '企業内ユーザー追加・削除',
          show: this.isAdmin,
        },
        // { path: '/setting/occupation-list', label: '募集中の職種分類設定', show: this.isCreateReviewUser },
        {
          path: '/setting/change-password',
          label: 'パスワード変更',
          show: this.globalUser,
        },
      ];
      let filteredLinks = links.filter((link) => link.show);
      return filteredLinks[0];
    },
  },
  mounted() {
    this.loadCurrentUser();
    this.loadCurrentUserDefaultSearch();
    this.loadReceivedContactsCount();
    this.loadReviewLists();
    this.loadAssignedReviewLists();
  },

  methods: {
    ...mapActions({
      loadCurrentUser: 'loadCurrentUser',
      loadCurrentUserDefaultSearch: 'loadCurrentUserDefaultSearch',
      loadReceivedContactsCount: 'loadReceivedContactsCount',
      loadAllJDs: 'jd/getAllJDs',
      loadReviewLists: 'loadReviewLists',
      loadAssignedReviewLists: 'loadAssignedReviewLists',
      checkAssignedReviewList: 'checkAssignedReviewList',
    }),
    ...mapMutations({
      clearAll: 'jd/clearAll',
      clearAllJds: 'jd/clearAllJDs',
    }),
    handleJDListClick(event) {
      if (this.$route.path === '/job-description-list/user-filter') {
        event.preventDefault();
        this.clearAll();
        this.clearAllJDs();
        this.loadAllJDs();
      }
    },
    logout() {
      this.$router.push('/logout');
    },

    showPendingReviewTab() {
      if(!this.isCreateReviewUser) return true;
      if(this.assignedReviewLists && this.assignedReviewLists.length) {
       const firstAssigned = this.assignedReviewLists[0];
       if(firstAssigned && firstAssigned._id) {
          this.checkAssignedReviewList(firstAssigned._id);
          return this.hasAssignedApplicants;
        }
      }
      return false;
    },
  },
};
</script>
<style scoped>
.company-section {
  max-width: 400px;
}
#unreadCount {
  margin-bottom: 12px;
  margin-right: 2px;
  color: #fff;
  font-size: 12px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #006C6B;
}

.font-15 {
  font-size: 15px;
}

.custom-alert {
  position: absolute;
  left: 0;
  right: 0;
  width: 30%;
  margin-left: auto;
  margin-right: auto;
  z-index: 100;
}

p {
  color: #3c3c3c;
  font-size: 14px;
}

.header-list .router-link-active {
  color: #006c6b !important;
  font-weight: bold;
  border-bottom: 4px solid #006c6b;
}

.header-ul {
  gap: 45px;
}

.header-ul a {
  color: #3c3c3c;
  text-decoration: none;
}

.header-ul a:hover {
  color: #006c6b;
}
</style>
